module.exports = __webpack_public_path__ + "static/media/mist_demo2.5cea904f.png";